<template>
  <!--
    WHAT — Metric Insight detail tab "Data Source". Edits the fact join graph the
      insight renders from (commonly a single fact DA). Wraps JoinGraphSection
      (→ StudioJoinBuilder).

    CONTRACT — reads record.studio_config (defaults to { steps: [] }). On change
      emits patch({ studio_config: { steps [, primary_key_columns] } }), only
      including primary_key_columns when the builder supplied a non-empty list.
      Re-emits refresh() when a DataAttribute is saved from the builder.

    NOTES — unlike the worklist Data Source, NO sql-url is passed: insights have
      no /studio-sql/ endpoint, so JoinGraphSection just shows the declared steps
      (no combined-SQL preview). studio_config is a computed pass-through — no
      local hydration state / hydrating guard needed. selfChrome: true —
      JoinGraphSection draws its own card, so this body renders bare.
  -->
  <!-- Metric Insight "Data Source" — the fact join graph the insight renders
       (often a single fact DA). No studio-sql endpoint for insights; the graph
       is small, so JoinGraphSection shows the declared steps. Patches studio_config. -->
  <JoinGraphSection
    :value="studioConfig"
    :attributes="context.attributes || []"
    @update:value="onStudio"
    @attribute-saved="$emit('refresh')"
  />
</template>

<script>
import JoinGraphSection from './JoinGraphSection.vue';

export default {
  name: 'InsightDataSourceSection',
  components: { JoinGraphSection },
  props: {
    record: { type: Object, required: true },
    artifact: { type: Object, required: true },
    context: { type: Object, default: () => ({}) },
  },
  emits: ['patch', 'refresh'],
  computed: {
    studioConfig() { return this.record.studio_config || { steps: [] }; },
  },
  methods: {
    onStudio(sc) {
      const out = { steps: sc.steps };
      if ((sc.primary_key_columns || []).length) out.primary_key_columns = [...sc.primary_key_columns];
      this.$emit('patch', { studio_config: out });
    },
  },
};
</script>
